<div class="mobile-menu__topbar">
  <button
    #triggerButton
    type="button"
    class="mobile-menu__trigger"
    [attr.aria-expanded]="isDrawerOpen"
    aria-controls="mobile-menu-drawer"
    aria-label="Open navigation menu"
    (click)="openDrawer()">
    <mat-icon fontSet="material-symbols-outlined">menu</mat-icon>
  </button>
</div>

@if (isDrawerOpen) {
  <div class="mobile-menu__scrim" (click)="closeDrawer()"></div>

  <div
    id="mobile-menu-drawer"
    class="mobile-menu__drawer"
    role="dialog"
    aria-modal="true"
    aria-label="Navigation menu"
    cdkTrapFocus
    cdkTrapFocusAutoCapture
    (keydown.escape)="closeDrawer()">
    <div class="mobile-menu__header">
      <a routerLink="/" class="mobile-menu__logo" (click)="onNavigate()"></a>
      <button type="button" class="mobile-menu__close" aria-label="Close navigation menu" (click)="closeDrawer()">
        <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
      </button>
    </div>

    <div class="mobile-menu__body">
      @if (userInfo$ | async; as userInfo) {
        @for (item of items; track item.label) {
          @if (isItemVisible(item, userInfo.modules)) {
            @if (item.children?.length) {
              <button
                type="button"
                class="mobile-menu__item mobile-menu__item--toggle"
                [class.mobile-menu__item--open]="isAdminExpanded"
                [class.mobile-menu__item--active]="isAdminActive && !isAdminExpanded"
                [attr.aria-expanded]="isAdminExpanded"
                aria-haspopup="true"
                aria-controls="mobile-menu-admin-tray"
                (click)="toggleAdmin()">
                <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span class="mobile-menu__item--label">{{ item.label }}</span>
                <mat-icon
                  class="material-symbols-outlined mobile-menu__item--chevron"
                  [class.mobile-menu__item--chevron-open]="isAdminExpanded"
                  >expand_more</mat-icon
                >
              </button>
              <div
                id="mobile-menu-admin-tray"
                class="mobile-menu__tray"
                [style.max-height.px]="isAdminExpanded ? visibleChildren(item, userInfo.modules).length * 44 + 12 : 0">
                <div class="mobile-menu__tray-inner">
                  @for (child of visibleChildren(item, userInfo.modules); track child.label) {
                    <a
                      class="mobile-menu__item--child"
                      [routerLink]="child.path"
                      routerLinkActive="mobile-menu__item--child-active"
                      #childLinkActive="routerLinkActive"
                      [attr.aria-current]="childLinkActive.isActive ? 'page' : null"
                      (click)="onNavigate()">
                      {{ child.label }}
                    </a>
                  }
                </div>
              </div>
            } @else if (item.isInternalUrl) {
              <a
                class="mobile-menu__item"
                [routerLink]="item.path"
                routerLinkActive="mobile-menu__item--active"
                #itemLinkActive="routerLinkActive"
                [attr.aria-current]="itemLinkActive.isActive ? 'page' : null"
                (click)="onNavigate()">
                <mat-icon fontSet="material-symbols-outlined">{{ item.icon }}</mat-icon>
                <span class="mobile-menu__item--label">{{ item.label }}</span>
              </a>
            } @else {
              <a
                class="mobile-menu__item"
                [href]="item.claimName | urlPerEnvironment"
                target="_blank"
                (click)="onNavigate()">
                <img
                  class="mobile-menu__item--external-icon"
                  ngSrc="/icons/sgl_arrows_white.png"
                  alt=""
                  height="13"
                  width="18" />
                <span class="mobile-menu__item--label">{{ item.label }}</span>
              </a>
            }
          }
        }
      }
    </div>

    @if (userInfo$ | async; as userInfo) {
      <button
        type="button"
        class="mobile-menu__footer"
        aria-haspopup="dialog"
        [attr.aria-label]="'Account options for ' + userInfo.displayName"
        (click)="openAccountSheet()">
        <app-avatar
          class="mobile-menu__footer--avatar"
          [size]="38"
          [displayName]="userInfo.displayName"
          [photoUrl]="userInfo.photoUrl ?? null"></app-avatar>
        <div class="mobile-menu__footer--info">
          <span class="mobile-menu__footer--name" [appEllipsisTooltip]="userInfo.displayName">{{
            userInfo.displayName
          }}</span>
          @if (userInfo.jobRole) {
            <span class="mobile-menu__footer--role" [appEllipsisTooltip]="userInfo.jobRole">{{
              userInfo.jobRole
            }}</span>
          }
        </div>
      </button>
    }

    @if (isAccountSheetOpen) {
      <div class="mobile-menu__sheet-scrim" (click)="closeAccountSheet()"></div>

      @if (userInfo$ | async; as userInfo) {
        <div
          class="mobile-menu__sheet"
          role="dialog"
          aria-modal="true"
          aria-label="Account"
          cdkTrapFocus
          cdkTrapFocusAutoCapture
          (keydown.escape)="closeAccountSheet()">
          <div class="mobile-menu__sheet-header">
            <app-avatar
              class="mobile-menu__sheet-header--avatar"
              [size]="42"
              color="var(--sgl-red)"
              textColor="var(--sgl-white)"
              [displayName]="userInfo.displayName"
              [photoUrl]="userInfo.photoUrl ?? null"></app-avatar>
            <div class="mobile-menu__sheet-header--info">
              <span class="mobile-menu__sheet-header--name">{{ userInfo.displayName }}</span>
              <span class="mobile-menu__sheet-header--email">{{ userInfo.email }}</span>
            </div>
            <button
              type="button"
              class="mobile-menu__sheet-close"
              aria-label="Close account sheet"
              (click)="closeAccountSheet()">
              <mat-icon fontSet="material-symbols-outlined">close</mat-icon>
            </button>
          </div>

          <div class="mobile-menu__sheet-body">
            <!-- <div class="mobile-menu__sheet-item mobile-menu__sheet-item--disabled" aria-disabled="true">
              <mat-icon fontSet="material-symbols-outlined">notifications</mat-icon>
              <span>Notifications</span>
            </div>
            <div class="mobile-menu__sheet-divider"></div> -->
            <button type="button" class="mobile-menu__sheet-item mobile-menu__sheet-item--logout" (click)="logout()">
              <mat-icon fontSet="material-symbols-outlined">logout</mat-icon>
              <span>Log out</span>
            </button>
          </div>
        </div>
      }
    }
  </div>
}
